import React, { useEffect } from "react";
import TMHBanner from "../../components/TMHBannerv2/TMHBanner";
import "./ConfirmEmailSuccessPage.scss";
import config from "../../config.json"
import TMHFooter from "../../components/TMHFooterv2/TMHFooter";
import { useParams } from 'react-router-dom';
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"
import LogoImg from "./logo.png"
import validator from 'validator'

export default function ConfirmEmailSuccessPage() {
  useTitle("Confirm Email Success - The Movie House TV")
  useEffect(() => {
    if (!validator.isEmail(email)) {
      alert("An error occurred, please try again!")
      window.open("about:blank", "_self");
      window.close();
      return
    }

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cache-Control", "no-cache");

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({
        "email": email,
        "hash": hash
      }),
    };
    fetch(config.baseUrl + "confirm_email", requestOptions)
      .then(response => response.json())
      .then(
        (result) => {
          alert(result.message)

          window.open("about:blank", "_self");
          window.close();
        },
        (error) => {
          console.log(error)
          alert("An error occurred, please try again!")
          window.open("about:blank", "_self");
          window.close();
        }
      )

    ReactGA.send("pageview")
  })

  const { email, hash } = useParams();

  return (
    <>
      <TMHBanner onlyGradient="true" />
      <div className="custom-banner" />
      <div className="confirm-email-page">
        <a href="/">
          <img className="logo-v2" src={LogoImg} alt="Movie House logo" />
        </a>
        <div className="content-gr">
          <div className="title">Your email is confirmed</div>
          <div className="description">
            Thank you! your email {email} is now confirmed and your bonus % will be added to your account shortly.
          </div>
          <button className="close-button" onClick={()=>{
            window.open("about:blank", "_self");
            window.close();
          }}>Close</button>
        </div>

      </div>
      <TMHFooter isFixed="true" />
    </>
  )
}
